module.exports = __webpack_public_path__ + "img/sy-name.216b5476.svg";